import { g as H, c as x, i as y, a as O, b as R } from "./general-BkFCKlQ-.js";
import { a as W, c as j, f as k, b as B, d as C, e as I, h as P, l as $, i as A } from "./format-Cc3xCl5M.js";
const F = ({ inputRef: f, dropDownRef: c, positionX: g, positionY: e }) => {
  const p = typeof f == "function" ? f() : f, l = typeof c == "function" ? c() : c;
  if (!p || !l)
    return {};
  const t = p == null ? void 0 : p.getBoundingClientRect(), o = l == null ? void 0 : l.offsetHeight, n = l == null ? void 0 : l.offsetWidth, a = window.innerHeight - (t == null ? void 0 : t.bottom), r = t == null ? void 0 : t.top, h = t == null ? void 0 : t.left, T = window.innerWidth - (t == null ? void 0 : t.right), m = window.innerWidth;
  let i, b;
  const v = e === "top" || e === "bottom", D = (t == null ? void 0 : t.top) - o - 10 + "px", w = `${t == null ? void 0 : t.bottom}px`;
  e === "top" && (i = D), e === "bottom" && (i = w), a > o && !v ? i = w : (r > o && !v || a < o && e === "bottom" && r > o) && (i = D), (!(a > o) && !(r > o) && !v || e === "top" && !(r > o) || e === "bottom" && !(a > o) && !(r > o)) && (i = "0px");
  let s = 0;
  if (g === "left")
    s = h >= n ? h - n : 0;
  else if (g === "right")
    s = T >= n ? t == null ? void 0 : t.right : m - n;
  else {
    const d = (t == null ? void 0 : t.left) + (t == null ? void 0 : t.width) / 2, u = n / 2;
    s = d - u >= 0 && d + u <= m ? d - u : d - u < 0 ? 0 : m - n;
  }
  return b = `${s}px`, { top: i, left: b };
}, X = () => ({ getToday: H, convertDateObjectToDate: W, convertDateToDateObject: j, checkIfItsTodayDate: x, isBeforeDate: y, getMonthName: O, formatDate: k, clickOutside: R, convert24HourTo12Hour: B, getAmPm: C, convert12HourTo24Hour: I, getCurrentTime: P, smartDropDownPosition: F, labelFormat: $, leadingZeros: A });
export {
  X as e
};
